import { SectionTitle, SectionWrapper } from '@/components';
import breakpoint from '@/constants/theme/breakpoint';
import { useMyParcelsContext, useShipmentsOverviewContext } from '@/modules/pmt/context';
import { DefaultTrackingContainer } from '../DefaultTrackingContainer';
import { TrackingDetails } from '../TrackingDetails';
import { NoParcelsFoundPanel } from './components/NoParcelsFoundPanel';

export const MyParcelsRightSection = () => {
  const { trackingTranslation } = useMyParcelsContext();
  const { noShipmentsFound, noShipmentsAdded } = useShipmentsOverviewContext();

  if (noShipmentsAdded) {
    return (
      <SectionWrapper breakpoint={breakpoint.breakpointKeys.lg}>
        {trackingTranslation.sectionTitleDesktop && (
          <SectionTitle>{trackingTranslation.sectionTitleDesktop}</SectionTitle>
        )}
        <DefaultTrackingContainer />
      </SectionWrapper>
    );
  }

  if (noShipmentsFound) {
    return (
      <SectionWrapper breakpoint={breakpoint.breakpointKeys.lg}>
        <NoParcelsFoundPanel />
      </SectionWrapper>
    );
  }

  return <TrackingDetails />;
};
